// router/index.js
import { createRouter, createWebHistory } from 'vue-router';
import WcSearchFormPage from '@/pages/WcSearchFormPage.vue';
import RiskySearchFromPage from '@/pages/RiskySearchFromPage.vue';
import StockSearchFormPage from '@/pages/StockSearchFormPage.vue';
import StockSearchFormPageXQ from '@/pages/StockSearchFormPageXQ.vue';
import StockAnalysisChartPage from '@/pages/StockAnalysisChartPage.vue';
import CalculationTabPage from '@/pages/CalculationTabPage.vue';
import ChildComponentPage from '@/pages/ChildComponentPage.vue';
import ToolsPage from '@/pages/ToolsPage.vue';
import FirstBuyPage from '@/pages/FirstBuyPage.vue';
import StockDetailPage from '@/pages/StockDetailPage.vue';
import ArticleListPage from '@/pages/ArticleListPage.vue';
import ArticleDetailPage from '@/pages/ArticleDetailPage.vue';
import ProfitCalculatorPage from '@/pages/ProfitCalculatorPage.vue';
import FundsFlowPage from '@/pages/FundsFlowPage.vue';
import UploadFilePage from '@/pages/UploadFilePage.vue';
import Login from '@/pages/LoginPage.vue';
import Member from '@/pages/MemberPage.vue';
import Register from '@/pages/RegisterPage.vue';
import GnLinkList from '@/pages/GnLinkList.vue';
import KplIndexPage from '@/pages/KplIndexPage.vue';
import GroupManagement from '@/pages/GroupManagement.vue';
import UserManagement from '@/pages/UserManagement.vue';
import UserRecordsPage from '@/pages/UserRecordsPage.vue';
import MenuManagement from '@/pages/MenuManagement.vue';
import CustomerManagement from '@/pages/CustomerManagement.vue';
import SegmentedSearchFormPage from '@/pages/SegmentedSearchFormPage.vue';
import UncappedSearchFromPage from '@/pages/UncappedSearchFromPage.vue';

import RulesPage from '@/pages/RulesPage.vue';
import OptionPage from '@/pages/OptionPage.vue';
import KnockOutPage from '@/pages/KnockOutPage.vue';


import OrderPage from '@/pages/OrderPage.vue';

import XueQiuNews from '@/pages/XueQiuNews.vue';

import ClsPage from '@/pages/ClsPage.vue';
import ViewReportPage from '@/pages/ViewReportPage.vue';
import DailyPage from '@/pages/DailyPage.vue';

import store from '@/store'; // 假设你的 Vuex store 文件路径为 '@/store'

const routes = [
  {
    path: '/wc-search-form',
    name: 'WcSearchFormPage',
    component: WcSearchFormPage,
    meta: { requiresAuth: true }
  },

   {
    path: '/risky-search-form',
    name: 'RiskySearchFromPage',
    component:RiskySearchFromPage,
    meta: { requiresAuth: true }
  },
   {
    path: '/order',
    name: 'OrderPage',
    component:OrderPage,
    meta: { requiresAuth: true }
  },

  {
    path: '/stock-search-form',
    name: 'StockSearchFormPage',
    component: StockSearchFormPage,
    meta: { requiresAuth: true }
  },
    {
    path: '/stock-search-form-xq',
    name: 'StockSearchFormPageXQ',
    component: StockSearchFormPageXQ,
    meta: { requiresAuth: true }
  },

  {
    path: '/uncapped-search-form',
    name: 'UncappedSearchFromPage',
    component: UncappedSearchFromPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/stock-analysis-chart',
    name: 'StockAnalysisChartPage',
    component: StockAnalysisChartPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/calculation-tab',
    name: 'CalculationTabPage',
    component: CalculationTabPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/child-component',
    name: 'ChildComponentPage',
    component: ChildComponentPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/tools-component',
    name: 'ToolsPage',
    component: ToolsPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/first-buy',
    name: 'FirstBuyPage',
    component: FirstBuyPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/stock-detail',
    name: 'StockDetailPage',
    component: StockDetailPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/article-list',
    name: 'ArticleListPage',
    component: ArticleListPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/article_detail',
    name: 'ArticleDetail',
    component: ArticleDetailPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/profitcalculator',
    name: 'ProfitCalculatorPage',
    component: ProfitCalculatorPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/funds_flow',
    name: 'FundsFlowPage',
    component: FundsFlowPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/upload_file',
    name: 'UploadFilePage',
    component: UploadFilePage,
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'LoginPage',
    component: Login
  },
  {
    path: '/member',
    name: 'MemberPage',
    component: Member,
    meta: { requiresAuth: true }
  },


  {
    path: '/register',
    name: 'RegisterPage',
    component: Register,
    meta: { requiresAuth: false }
  },
  {
    path: '/linkList',
    name: 'GnLinkList',
    component: GnLinkList,
    meta: { requiresAuth: true }
  },
  {
    path: '/kpl',
    name: 'Kplindex',
    component: KplIndexPage,
    meta: { requiresAuth: true }
  },
  {
      path: '/user-records',
      name: 'UserRecords',
      component:UserRecordsPage,
      meta: { requiresAuth: true }
  },
   {
    path: '/user-member',
    name: 'UserManagement',
    component: UserManagement,
    meta: { requiresAuth: true }
  },
     {
    path: '/customer-management',
    name: 'CustomerManagement',
    component: CustomerManagement,
    meta: { requiresAuth: true }
  },


   {
      path: '/group-management',
      name: 'GroupManagement',
      component: GroupManagement,
      meta: { requiresAuth: true }
  },
  {
      path: '/menu-management',
      name: 'MenuManagement',
      component: MenuManagement,
      meta: { requiresAuth: true }
  },
    {
      path: '/segmented-search',
      name: 'SegmentedSearchFormPage',
      component: SegmentedSearchFormPage,
      meta: { requiresAuth: true }
  },

    {
      path: '/xueqiu-news',
      name: 'XueQiuNews',
      component: XueQiuNews,
      meta: { requiresAuth: true }
  },
      {
      path: '/cls',
      name: 'ClsPage',
      component: ClsPage,
      meta: { requiresAuth: true }
  },
    {
      path: '/rules',
      name: 'RulesPage',
      component: RulesPage,
      meta: { requiresAuth: true }
  },{

    path: '/option',
    name: 'OptionPage',
    component: OptionPage,
    meta: { requiresAuth: false }

  },{

    path: '/knock-out',
    name: 'KnockOutPage',
    component: KnockOutPage,
    meta: { requiresAuth: false }

  },{

    path: '/view-report',
    name: 'ViewReportPage',
    component: ViewReportPage,
    meta: { requiresAuth: false }
  },
  {

    path: '/daily',
    name: 'DailyPage',
    component: DailyPage,
    meta: { requiresAuth: false }
  },

  {
    path: '/',
    redirect: '/login' // 默认重定向到登录页面
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const isLoggedIn = store.getters.isLoggedIn;

  console.log('isLoggedIn:', isLoggedIn);
  console.log('requiresAuth:', requiresAuth);

  if (requiresAuth && !isLoggedIn) {
    // 如果需要验证且未登录，先检查 token
    await store.dispatch('checkToken');
    if (!store.getters.isLoggedIn) {
      next({ name: 'LoginPage' });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
